import store from '@/store'
const user = store.state.auth.user
const userRole = user?.user_role

const menu = [
  {
    title: 'dashboard',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'To Do',
    route: 'to-do',
    icon: 'BellIcon',
    count: 0,
  },
  {
    title: 'invoices',
    route: 'invoices',
    icon: 'FileTextIcon',
  },
  {
    title: 'companies',
    route: 'companies',
    icon: 'CodesandboxIcon',
  },
  {
    title: 'Companies ToDo',
    route: 'todo',
    icon: '',
  },
  {
    title: 'transaction_currency',
    route: 'transaction_currency',
    icon: 'CreditCardIcon',
  },
  {
    title: 'referral_program',
    route: 'referral_program',
    additionalRegexRoute: /^\/referral-program\/.+$/,
    icon: 'GiftIcon',
  },
  {
    title: 'documents',
    route: 'documents',
    icon: 'FileIcon',
    children: [
      {
        title: 'all',
        route: 'documents',
        icon: 'ListIcon',
      },
      {
        title: 'document_requests',
        route: 'document_requests',
        icon: 'SendIcon',
      },

    ]
  },
  {
    title: 'users',
    route: 'users',
    icon: 'UsersIcon',
    children: [
      {
        title: 'all',
        route: 'users',
        icon: 'ListIcon',
      },
      {
        title: 'sellers',
        route: 'sellers',
        icon: 'DollarSignIcon',
      },
      {
        title: 'investors',
        route: 'investors',
        icon: 'TrendingUpIcon',
      },
      {
        title: 'investment_profiles',
        route: 'investment_profile',
        icon: 'DatabaseIcon',
      },
      {
        title: 'partners',
        route: 'partners',
        icon: 'CodeIcon',
      },
    ]
  },
  {
    title: 'admin_management',
    route: 'admin_management',
    icon: 'UsersIcon',
    hideFor: ['admin_type_a','admin_type_b'],
  },

  {
    title: "reports_and_logs",
    icon: 'ActivityIcon',
    children: [
      {
        title: 'Transaction Report',
        route: 'transaction_report',
        icon: 'BarChart2Icon',
      },
      {
        title: 'debtor_ips',
        route: 'debtor_ips',
        icon: 'CompassIcon',
      },
      {
        title: 'IP Logins',
        route: 'ip-logins',
        icon: 'UserIcon',
      },
      {
        title: 'action_logs',
        route: 'action_logs',
        icon: 'ActivityIcon',
      },
      {
        title: 'email_logs',
        route: 'email_logs',
        icon: 'MailIcon',
      },
    ]
  },
  {
    title: 'email',
    icon: 'MailIcon',
    children: [
      {
        title: 'send_email',
        route: 'send_email',
        icon: 'MailIcon',
      },
      {
        title: 'send_admin_email',
        route: 'send_admin_email',
        icon: 'MailIcon',
      },
      {
        title: 'email_testing',
        route: 'email_testing',
        icon: 'MailIcon',
      },
    ]
  },
  {
    title:"other",
    children:[
      {
        title: 'currency',
        route: 'currency',
        icon: 'DollarSignIcon',
      },
      {
        title: 'zoho_leads',
        route: 'zoho_leads',
        icon: 'CodesandboxIcon',
      },
      {
        title: 'settings',
        route: 'settings',
        icon: 'SettingsIcon',
      },
      {
        title: 'scoring_settings',
        route: 'scoring_settings',
        icon: 'SettingsIcon',
      },
      {
        title: 'languages',
        route: 'languages',
        icon: 'GlobeIcon',
      },
    ]
  }

]

const filteredMenu = menu.filter(item => {
  return !(item.hideFor && item.hideFor.includes(userRole))
})

export default filteredMenu
